import React from "react"
import './index.css'

function Footer(){
    return (
        <footer id="footer">
            <h3><span>moebius </span>- by <b>Ivo Zayas</b></h3>
        </footer>
    )
}

export { Footer }